const ssr = true;
const trailingSlash = "ignore";
export {
  ssr,
  trailingSlash
};
